/** @typedef {{ x: number, y: number, width: number, height: number }} ViewportRect */

/**
 * @param {import('pdfjs-dist').PageViewport} viewport
 * @param {{ x0: number, y0: number, x1: number, y1: number }} bbox
 * @returns {ViewportRect}
 */
export function pdfRectToViewport(viewport, bbox) {
  const [vx1, vy1, vx2, vy2] = viewport.convertToViewportRectangle([
    bbox.x0,
    bbox.y0,
    bbox.x1,
    bbox.y1,
  ]);
  return {
    x: Math.min(vx1, vx2),
    y: Math.min(vy1, vy2),
    width: Math.abs(vx2 - vx1),
    height: Math.abs(vy2 - vy1),
  };
}

/**
 * @param {import('pdfjs-dist').PageViewport} viewport
 * @param {ViewportRect} rect
 * @returns {{ x0: number, y0: number, x1: number, y1: number }}
 */
export function viewportRectToPdf(viewport, rect) {
  const [x1, y1] = viewport.convertToPdfPoint(rect.x, rect.y);
  const [x2, y2] = viewport.convertToPdfPoint(rect.x + rect.width, rect.y + rect.height);
  return {
    x0: Math.min(x1, x2),
    y0: Math.min(y1, y2),
    x1: Math.max(x1, x2),
    y1: Math.max(y1, y2),
  };
}
